export enum ReportType {
  PaidOrders = 'PaidOrders',
  Demographics = 'Demographics',
  Orders = 'Orders'
}
